module.exports = __webpack_public_path__ + "static/sl-county-11c227b19c289e777d3792dee380c7fe.svg";